<script setup>
import VideoCallMenuButton from "@/components/Common/VideoCallMenuButton.vue";
import VideoCallButton from "@/components/Common/VideoCallButton.vue";
import { sleep } from "@/utils";
import configurationProvider from "@/Core/configurationProvider";

import { ref } from 'vue';
import i18n from "@/i18n";

import { useVideoCallState } from "@/stores/videoCallState";
import { Actions, useEventEmitters } from "@events";

const props = defineProps({
  rtcId: {
    type: String,
    required: true,
  },

  // Adding this will prevent a vue.js warning
  sectionType: {
    type: String,
    required: false,
  },

  // Adding this will prevent a vue.js warning
  modelValue: {
    type: Object,
    required: false
  }
});

const screenShooterSettings = configurationProvider.getObject("SCREEN_SHOOTER_SETTINGS", { isWhisperSupervisorScreenShooterBtnEnabled: true, isAgentScreenShooterBtnEnabled: true });

const state = useVideoCallState(props.rtcId);
const { actionEmitter } = useEventEmitters(props.rtcId);

const actions = ref([
  {
    name: i18n.global.t("ECVScreenshot"),
    icon: "mdi-window-maximize",
    trigger: () => takeScreenshotBtnClick({ source: state.role, target: "ecv-window", by: state.name, type: state.disableVideoControls ? "hidden" : "visible", respond: true }),
  },
  {
    name: i18n.global.t("WholeScreenshot"),
    icon: "mdi-monitor-multiple",
    trigger: () => takeScreenshotBtnClick({ source: state.role, target: "whole-screens", by: state.name, type: state.disableVideoControls ? "hidden" : "visible", respond: true }),
  },
]);

const isBtnDisabled = ref(false);

async function takeScreenshotBtnClick(trigger) {
  isBtnDisabled.value = true;

  if (state.role == "supervisor") {
    // Supervisor sends signaling to agent — handled by the agent's ScreenShooterBridge
    actionEmitter.emit(Actions.SendSignalingMessage, {
      cmd: "send",
      msg: JSON.stringify({
        type: "screen-shooter:take-screenshot",
        trigger,
      }),
    });
  } else if (state.role == "agent") {
    // Emit action for the always-mounted ScreenShooterBridge to handle
    actionEmitter.emit("screenshooter-take-screenshot", trigger);
  }

  await sleep(1000 * 3);
  isBtnDisabled.value = false;
}
</script>

<template>
  <template v-if="state.role == 'agent' && screenShooterSettings.isAgentScreenShooterBtnEnabled">
    <VideoCallButton :icon="'mdi-image-filter-center-focus'" @click="takeScreenshotBtnClick({ source: state.role, target: 'ecv-window', by: state.name, type: 'self', respond: false })" :disabled="isBtnDisabled" />
  </template>
  <template v-else-if="state.role == 'supervisor' && screenShooterSettings.isWhisperSupervisorScreenShooterBtnEnabled">
    <VideoCallMenuButton :icon="'mdi-image-filter-center-focus'" :actions="actions" :disabled="isBtnDisabled" />
  </template>
</template>

<style scoped>

</style>